export function onLogoutResolver(__, {me, misc}) {
    return [
        me.resetData,
        // misc.setSavedAppMode,
        // misc.setSavedItinMode,
        misc.toggleAppMode,
        misc.toggleItinMode,
    ]
}